export const ReportSortTypes = {
  Alphabetically: "az",
  Capacity: "capacity",
  Portfolio: "portfolio",
  FuelType: "fuel"
};
